import {
    Backdrop,
    Button,
    Card,
    CardContent,
    Container,
    Fade,
    Grid,
    Menu,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Divider,
} from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { api } from '../../../services/Main/Api';
import { useSnackbar } from 'notistack';
import { useParams } from 'react-router-dom';
import Context from '../../../contexts/Context';
import Masks from '../../../components/Shared/Masks';
import { Helmet } from 'react-helmet';
import ExtraChargeFormSet from './ExtraChargeFormSet';
import ContractForm from './ContractForm/ContractForm';
import RentDocuments from './RentDocuments';
import ContractInvoices from './ContractInvoices';
import SimpleButtons from '../../../components/Shared/SimpleButtons';
import RentNotes from './RentNotes';
import RentSlipOptions from './RentSlipOptions/RentSlipOptions';
import RentWarranty from './RentWarranty';
import CircularProgress from '@mui/material/CircularProgress';
import RentWizard from './RentWizard';
import AnimationGlobal from '../../../components/Shared/animations/AnimationGlobal';
import successAnimation from '../../../assets/animations/success.json';
import ContractConclusionCard from './ContractConclusionCard';
import RecipientTransferCard from './RecipientTransferCard';
import RentContractFee from './RentContractFee';
import AutoTransfer from './RentRecipientSet/AutoTransfer';
import TerminateContractDetail from './ContractForm/TerminateContractDetail';
import TerminateContractForm from './ContractForm/TerminateContractForm';
import { Box } from '@mui/system';
import ActivityLog from '../ActivityLog/ActivityLog';
import RenterInfo from './ContractForm/RenterInfo';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SettingsIcon from '@mui/icons-material/Settings';
import PaidIcon from '@mui/icons-material/Paid';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import HistoryIcon from '@mui/icons-material/History';
import BeneficiariesFormSet from "./BeneficiariesFormSet";
import BeneficiariesTableView from "./BeneficiariesTableView";

const RentForm = () => {
    //////////////////////////////////////
    //// States, Provider and Hooks /////
    ////////////////////////////////////

    const params = useParams();
    const { id } = params;
    const {
        setFilters,
        unitOptions,
        userFiles,
        loadingModal,
        setLoadingModal,
        setDocuments,
        deleteApiFiles,
        setDeleteApiFiles,
        setDataProvider,
        dataProvider,
        setUserfiles,
        setRefreshScreen,
        screenRefresh,
    } = useContext(Context);
    const { enqueueSnackbar } = useSnackbar();
    const { activeStep, unitInfo } = dataProvider || {};

    const targetRef = useRef(null);

    const [reqData, setReqData] = useState({
        start_date: moment().format(),
        active: true,
        contract_type: 'residencial',
        administrative_tax: 10,
        intermediation_fee: 100,
        warning_date: moment().format('YYYY-MM-DD'),
        closing_date: moment().format('YYYY-MM-DD'),
        calculate_fine: false,
        number_of_months: null,
    });
    const [rentContractId, setRentContractId] = useState(false);
    const [edit, setEdit] = useState(false);
    const [error, setError] = useState(null);
    const [errorDocuments, setErrorDocuments] = useState(null);
    const [reqLoading, setReqLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(!!id);
    const [dataCharge, setDataCharge] = useState([]);
    const [taxDelete, setTaxDelete] = useState([]);
    const [loadingDocuments, setLoadingDocuments] = useState(!!id);
    const [rentNotes, setRentNotes] = useState([]);
    const [guaranteeData, setGuaranteeData] = useState({ due_date: moment() });
    const [insuranceData, setInsuranceData] = useState([]);
    const [guarantee, setGuarantee] = useState(null);
    const [insurance, setInsurance] = useState(reqData?.id);
    const [show, setShow] = useState(false);
    const [dataBond, setDataBond] = useState([]);
    const [bondDelete, setBondDelete] = useState([]);
    const [prevWarranty, setPrevWarranty] = useState(null);
    const { user } = useContext(Context);
    const { perm_bank } = user || {};
    const [contractLoad, setContractLoad] = useState(true);
    const [prevStateData, setPrevStateData] = useState(null);
    const [open, setOpen] = useState(false);

    // Menu de opções ao lado de Ajustar Fatura
    const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);
    const optionsMenuOpen = Boolean(optionsAnchorEl);

    // Dialog para RentSlipOptions (Configurar Fatura)
    const [openSlipDialog, setOpenSlipDialog] = useState(false);

    // Dialog para AutoTransfer (Configurar Repasse)
    const [openTransferDialog, setOpenTransferDialog] = useState(false);

    // Dialog para RentWarranty (Garantia / Seguro)
    const [openWarrantyDialog, setOpenWarrantyDialog] = useState(false);

    // Dialog para ActivityLog (Histórico)
    const [openActivityDialog, setOpenActivityDialog] = useState(false);

    ////////////////////////////
    //// General functions ////
    //////////////////////////

    function helmetTitle() {
        if (!id) {
            return 'Criação de contrato';
        } else {
            return 'Editar contrato';
        }
    }

    function initalDataFilter() {
        if (!params.id) {
            setDataProvider((prevState) => ({
                ...prevState,
                activeStep: 0,
                firstStep: false,
                secondStep: false,
                thirdStep: false,
                fourthStep: false,
                fifthStep: false,
            }));
        }
    }

    function resetFilters() {
        setDocuments([]);
        setDeleteApiFiles([]);
        setEdit(false);
        setFilters((prevState) => ({
            ...prevState,
            requestDone: !prevState.filters?.requestDone,
            load: true,
        }));
    }

    function withoutDoc() {
        userFiles?.length < 1 && deleteApiFiles?.length < 1 && resetFilters();
    }

    function warrantyChoice(rentId) {
        if (guarantee === 'credpago') {
            postCredPago(rentId);
        }

        if (guarantee === 'guarantor') {
            postGuarantor(rentId);
        }

        if (guarantee === 'bail_insurance') {
            postBailInsurance(rentId);
        }

        if (guarantee === 'titulo_de_captalização') {
            createCapitalization(rentId);
        }

        if (guarantee === 'deposit') {
            createEscrow(rentId);
        }
    }

    function stepComplete() {
        return (
            <Grid item xs={12}>
                <Card>
                    <Fade in={true} mountOnEnter unmountOnExit timeout={300}>
                        <CardContent>
                            <AnimationGlobal
                                text={'Etapa concluída'}
                                size={'200px'}
                                animation={successAnimation}
                                fontStyles={{ mb: '1rem' }}
                                fontSize={'20px'}
                            />
                        </CardContent>
                    </Fade>
                </Card>
            </Grid>
        );
    }

    function scrollToRecipients() {
        const targetPosition = targetRef.current?.offsetTop || 0;

        window.scrollTo({
            top: targetPosition - 50,
            behavior: 'smooth',
        });
    }

    function verifyPercentageSum(array) {
        let soma = 0;
        for (let i = 0; i < array.length; i++) {
            soma += +array[i].percentage;
        }
        return soma;
    }

    function percentFilter(array) {
        if (
            verifyPercentageSum(array) !== 100 &&
            dataProvider?.afterDelete === undefined &&
            array?.length > 0
        ) {
            scrollToRecipients();
            setDataProvider((prevState) => ({
                ...prevState,
                edit: true,
            }));
            enqueueSnackbar('Distribuição dos beneficiários estão incorretas, por favor refaça', {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                },
            });
        }
    }

    /////////////////////////////
    //////// Requisitions ///////
    /////////////////////////////

    function getContract(param, refresh) {
        !refresh && setIsLoading(true);
        const rentId = param || dataProvider?.rentId;
        api
            .get(`rent_contract/${id ?? rentId}/`)
            .then((response) => {
                setPrevStateData({
                    ...response.data,
                    value: Masks.money(response.data.value.toString()),
                });
                setReqData({
                    ...response.data,
                    value: Masks.money(response.data.value.toString()),
                });
                setDataProvider((prevState) => ({
                    ...prevState,
                    contractValue: response.data.value,
                    autoTransfer: response.data.auto_transfer,
                    transferDay: response.data.transfer_day,
                    transferGuaranteed: response.data.transfer_guaranteed,
                    transferGuaranteedDuration: response.data.transfer_guaranteed_duration,
                    administrativeTaxAmount: response.data.administrative_tax_amount,
                    readjustmentIndex: response.data.readjustment_index,
                }));
                getGuarantee(response.data.guarantee);
                getInsurance();
                setDataProvider((prevState) => ({
                    ...prevState,
                    insurance: response.data.insurance,
                }));
                setGuarantee(response.data.guarantee);
                dataProvider?.skelAuth &&
                setDataProvider((prevState) => ({
                    ...prevState,
                    skelWarranty: false,
                }));
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                !refresh && setIsLoading(false);
                setContractLoad(false);
            });
    }



    function getDocuments(refresh) {
        !refresh && setLoadingDocuments(true);
        api
            .get(`/rent_contract/document/`, { params: { rent_contract_id: id } })
            .then((response) => {
                setDocuments(response.data.results);
            })
            .catch((error) => {
                console.log(error);
                setErrorDocuments(error.data);
            })
            .finally(() => {
                !refresh && setLoadingDocuments(false);
            });
    }

    function detailedUnit() {
        !reqData?.unit && setDataProvider((prevState) => ({ ...prevState, unitInfo: null }));

        if (reqData?.unit) {
            api
                .get(`/unit/${reqData?.unit?.id ?? reqData?.unit}/`)
                .then((response) => {
                    setDataProvider((prevState) => ({ ...prevState, unitInfo: response.data }));
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }

    function getBonds(deleteReq, refresh) {
        if (id || dataProvider?.rentId) {
            !refresh && setIsLoading(true);
            api
                .get(
                    `/rent_recipient/signed_recipient/?rent_contract_id=${id ?? (id | dataProvider?.rentId)}`
                )
                .then((response) => {
                    setDataBond(response.data.results);
                    percentFilter(response.data.results);
                    deleteReq &&
                    setDataProvider((prevState) => ({
                        ...prevState,
                        deleteBondDone: !dataProvider?.deleteBondDone,
                    }));
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    !refresh && setIsLoading(false);
                });
        }
    }

    function getGuarantee(guarantee) {
        if (guarantee) {
            const url =
                (guarantee === 'credpago' && `rent_contract/cred_paid/`) ||
                (guarantee === 'guarantor' && `rent_contract/guarantor/`) ||
                (guarantee === 'bail_insurance' && `rent_contract/bail_insurance/`) ||
                (guarantee === 'titulo_de_captalização' &&
                    `rent_contract/capitalization_bond/`) ||
                (guarantee === 'deposit' && `rent_contract/deposit/`);

            const rentId = id || dataProvider?.rentId;

            api
                .get(url, { params: { rent_contract: rentId } })
                .then((response) => {
                    const { value, phone, cep, cpf_cnpj } = response?.data?.results[0] || {};
                    setGuaranteeData({
                        ...response.data.results[0],
                        ...(value && { value: Masks.money(value.toString()) }),
                        ...(phone && { phone: `${phone}-` }),
                        ...(cep && { cep: `${cep}-` }),
                        ...(cpf_cnpj && { cpf_cnpj: `${cpf_cnpj}-` }),
                    });
                    setPrevWarranty({
                        ...response.data.results[0],
                        ...(value && { value: Masks.money(value.toString()) }),
                        ...(phone && { phone: `${phone}-` }),
                        ...(cep && { cep: `${cep}-` }),
                        ...(cpf_cnpj && { cpf_cnpj: `${cpf_cnpj}-` }),
                    });
                    setDataProvider((prevState) => ({ ...prevState, skelWarranty: false }));
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }

    async function getInsurance(insurance) {
        if (id || dataProvider?.rentId) {
            const rentId = id || dataProvider?.rentId;
            try {
                const response = await api.get('/rent_contract/insurance/', {
                    params: { rent_contract: rentId },
                });
                setInsuranceData(response.data.results);
            } catch (error) {
                console.log(error);
            }
        }
    }





    function update(fromWarranty, nullifyInsurance, nullifyGuarantee) {
        const {
            start_date,
            value,
            bankslip_fine_value,
            bankslip_interest_value,
            bankslip_discount_value,
            contract_time,
            administrative_tax,
            intermediation_fee,
            readjustment_index,
        } = reqData || {};

        const data = {
            ...reqData,
            start_date: moment(start_date).format('YYYY-MM-DD'),
            contract_time: +contract_time,
            value: value?.includes('R$') && value?.replace(/\D+/g, ''),
            bankslip_fine_value: bankslip_fine_value
                ? bankslip_fine_value?.toString().replace(/\D+/g, '')
                : null,
            bankslip_interest_value: bankslip_interest_value
                ? bankslip_interest_value?.toString()?.replace(/\D+/g, '')
                : null,
            bankslip_discount_value: bankslip_discount_value
                ? bankslip_discount_value?.toString()?.replace(/\D+/g, '')
                : null,
            insurance: !nullifyInsurance ? insurance : null,
            guarantee: !nullifyGuarantee ? guarantee : null,
            administrative_tax:
                administrative_tax != null
                    ? +administrative_tax?.toString()?.replace(/,/g, '.')
                    : 0,
            intermediation_fee:
                intermediation_fee != null
                    ? +intermediation_fee?.toString()?.replace(/,/g, '.')
                    : 0,
            readjustment_index: readjustment_index,
        };

        if (id || dataProvider?.rentId) {
            const rentId = id || dataProvider?.rentId;
            setLoadingModal(true);
            api
                .put(`/rent_contract/${rentId}/`, data)
                .then((response) => {
                    withoutDoc();
                    rentId && taxDeleteReq();
                    setDataProvider((prevState) => ({
                        ...prevState,
                        thirdStep: true,
                        successObserver: !dataProvider?.successObserver,
                    }));
                    setRefreshScreen(screenRefresh);
                    rentId && warrantyChoice(rentId);
                    rentId &&
                    !fromWarranty &&
                    enqueueSnackbar('Contrato atualizado', { variant: 'success' });
                    fromWarranty &&
                    enqueueSnackbar('Garantia/Seguro atualizado', {
                        variant: 'success',
                    });
                    rentId && getContract(null, true);
                    getBonds(null, true);
                    setError(null);
                })
                .catch((error) => {
                    setError(error.response.data);
                    error.response.data.active &&
                    enqueueSnackbar(error.response.data.active, {
                        variant: 'error',
                    });
                    error.response.data[0] &&
                    enqueueSnackbar(error.response.data[0], {
                        variant: 'error',
                    });
                    error.response.data.administrative_tax &&
                    enqueueSnackbar(error.response.data.administrative_tax, {
                        variant: 'error',
                    });
                    error.response.data.value &&
                    enqueueSnackbar('É necessário definir um valor', {
                        variant: 'error',
                    });
                    error.response.data.unit &&
                    enqueueSnackbar('É necessário definir um imóvel', {
                        variant: 'error',
                    });
                    error.response.data.generate_bankslip_day &&
                    enqueueSnackbar(error.response.data.generate_bankslip_day, {
                        variant: 'error',
                    });
                    console.log(error);
                })
                .finally(() => {
                    setLoadingModal(false);
                });
        }
    }

    function documentPromise(rentId) {
        setLoadingModal(true);
        const postPromises = Array.isArray(userFiles)
            ? userFiles.map((file) =>
                api.post(
                    'rent_contract/document/',
                    {
                        file: file,
                        rent_contract: rentId || id,
                    },
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                )
            )
            : [];

        const deletePromises = Array.isArray(deleteApiFiles)
            ? deleteApiFiles.map((file) =>
                api.delete(`rent_contract/document/${file.id}`)
            )
            : [];

        const allPromises = Promise.all([...postPromises, ...deletePromises]);

        allPromises
            .then((responses) => {
                getDocuments(!!responses);
                setUserfiles([]);
                setDeleteApiFiles([]);
                params.id &&
                enqueueSnackbar('Documentos atualizados', { variant: 'success' });
            })
            .catch((error) => {
                console.log(error);
                params.id &&
                enqueueSnackbar('Erro ao atualizar documentos', {
                    variant: 'error',
                });
                enqueueSnackbar(error.response.data[0], { variant: 'error' });
            })
            .finally(() => {
                setLoadingModal(false);
            });
    }




    function postCredPago(rentId) {
        const { value, due_date } = guaranteeData || {};

        const data = {
            ...guaranteeData,
            ...(value?.includes('R$') && { value: value.replace(/\D+/g, '') }),
            due_date: moment(due_date).format('YYYY-MM-DD'),
            rent_contract: +rentId ?? params.id,
        };

        const alternateReq = !reqData?.guarantee
            ? api.post(`rent_contract/cred_paid/`, data)
            : api.put(`rent_contract/cred_paid/${guaranteeData?.id}/`, data);

        alternateReq
            .then((response) => {
                setShow(false);
                setDataProvider((prevState) => ({
                    ...prevState,
                    fourthStep: false,
                }));
            })
            .catch((error) => {
                console.log(error);
            });
    }

    function postGuarantor(rentId) {
        const { phone, cpf_cnpj, cep } = guaranteeData || {};

        const data = {
            ...guaranteeData,
            cpf_cnpj: cpf_cnpj?.replace(/\D+/g, ''),
            phone: phone?.replace(/\D+/g, ''),
            cep: cep?.replace(/\D+/g, ''),
            rent_contract: +rentId ?? params.id,
        };

        const alternateReq = !reqData?.guarantee
            ? api.post(`rent_contract/guarantor/`, data)
            : api.put(`rent_contract/guarantor/${guaranteeData?.id}/`, data);

        alternateReq
            .then((response) => {
                setShow(false);
                setDataProvider((prevState) => ({
                    ...prevState,
                    fourthStep: false,
                }));
            })
            .catch((error) => {
                console.log(error);
            });
    }

    function postBailInsurance(rentId) {
        const { value } = guaranteeData || {};

        const data = {
            ...guaranteeData,
            value: value?.replace(/\D+/g, ''),
            rent_contract: +rentId ?? params.id,
        };

        const alternateReq = !reqData?.guarantee
            ? api.post(`rent_contract/bail_insurance/`, data)
            : api.put(
                `rent_contract/bail_insurance/${guaranteeData?.id}/`,
                data
            );

        alternateReq
            .then((response) => {
                setShow(false);
                setDataProvider((prevState) => ({
                    ...prevState,
                    fourthStep: false,
                }));
            })
            .catch((error) => {
                console.log(error);
            });
    }

    async function createCapitalization(rentId) {
        try {
            const data = {
                ...guaranteeData,
                rent_contract: +rentId ?? params.id,
            };

            const alternateReq = !reqData?.guarantee
                ? await api.post(`rent_contract/capitalization_bond/`, data)
                : await api.put(
                    `rent_contract/capitalization_bond/${guaranteeData?.id}/`,
                    data
                );

            setShow(false);
            setDataProvider((prevState) => ({
                ...prevState,
                fourthStep: false,
            }));
        } catch (error) {
            console.error(error);
        }
    }

    async function createEscrow(rentId) {
        const { value } = guaranteeData || {};

        try {
            const data = {
                ...guaranteeData,
                rent_contract: +rentId ?? params.id,
                value: +value?.replace(/\D+/g, ''),
            };

            const alternateReq = !guaranteeData?.id
                ? await api.post(`rent_contract/deposit/`, data)
                : await api.put(
                    `rent_contract/deposit/${guaranteeData?.id}/`,
                    data
                );

            setShow(false);
            setDataProvider((prevState) => ({
                ...prevState,
                fourthStep: false,
            }));
        } catch (error) {
            console.error(error);
        }
    }

    function bondCreate(refresh, setIsSuccess, setActiveBackdrop) {
        const dataReq = dataBond.map((bond) => {
            return {
                ...bond,
                rent_contract: id ?? dataProvider?.rentId,
            };
        });

        const putRequests = dataReq.filter((bond) => bond.id);
        const postRequests = dataReq.filter((bond) => !bond.id);

        const putPromises = putRequests.map((bond) => {
            return api.put(`/rent_recipient/signed_recipient/${bond.id}/`, {
                percentage: +bond.percentage,
                recipient_account: bond.recipient_account,
                recipient_pix_key: bond?.recipient_pix_key,
            });
        });

        Promise.all(putPromises)
            .then((putResponses) => {
                const postPromises = postRequests.map((bond) => {
                    return api.post(`/rent_recipient/signed_recipient/`, {
                        percentage: +bond.percentage,
                        rent_contract: +bond.rent_contract,
                        recipient_account: bond.recipient_account,
                        recipient_pix_key: bond?.recipient_pix_key,
                        rent_recipient: bond?.rent_recipient,
                    });
                });

                return Promise.all(postPromises);
            })
            .then((postResponses) => {
                getBonds(null, refresh);
                getContract(dataProvider?.rentId, false);
                setDataProvider((prevState) => ({
                    ...prevState,
                    fifthStep: true,
                }));
                setIsSuccess(true);
            })
            .catch((error) => {
                setActiveBackdrop(false);
                console.log(error);
                enqueueSnackbar(
                    'Erro ao atualizar vínculo ou cadastrar beneficiário',
                    {
                        variant: 'error',
                    }
                );
                error.response?.data?.rent_contract?.[0] &&
                enqueueSnackbar(error.response.data.rent_contract[0], {
                    variant: 'error',
                });
            });
    }

    ////////////////////
    // -> 3 Delete /////
    ////////////////////

    function taxDeleteReq() {
        if (taxDelete?.length > 0) {
            taxDelete?.forEach((tax) => {
                api
                    .delete(`/rent_contract/tax/${tax?.id}/`)
                    .then((response) => {})
                    .catch((error) => {
                        console.log(error);
                    });
            });
        }
    }

    function taxDeleteById(taxId) {
        api
            .delete(`/rent_contract/tax/${taxId}/`)
            .then((response) => {
                enqueueSnackbar('Cobrança deletada', { variant: 'success' });
            })
            .catch((error) => {
                enqueueSnackbar('Erro ao excluir cobrança', {
                    variant: 'error',
                });
                console.log(error);
            });
    }

    function deleteBondById(param, refresh) {
        api
            .delete(`/rent_recipient/signed_recipient/${param}/`)
            .then((response) => {
                enqueueSnackbar('Beneficiário descadastrado', {
                    variant: 'success',
                });
                getBonds(!!response, refresh);
            })
            .catch(() => {
                enqueueSnackbar('Erro ao desvincular beneficiário', {
                    variant: 'error',
                });
            });
    }

    /////////////////////////////
    //// Handlers do Menu ///////
    /////////////////////////////

    const handleOpenOptionsMenu = (event) => {
        setOptionsAnchorEl(event.currentTarget);
    };

    const handleCloseOptionsMenu = () => {
        setOptionsAnchorEl(null);
    };

    const handleConfigureInvoice = () => {
        handleCloseOptionsMenu();
        setOpenSlipDialog(true); // abre dialog de configuração de fatura
    };

    const handleConfigureTransfer = () => {
        handleCloseOptionsMenu();
        setOpenTransferDialog(true); // abre dialog de configuração de repasse
    };

    const handleConfigureWarranty = () => {
        handleCloseOptionsMenu();
        setOpenWarrantyDialog(true); // abre dialog de Garantia / Seguro
    };

    const handleOpenActivity = () => {
        handleCloseOptionsMenu();
        setOpenActivityDialog(true); // abre dialog de histórico
    };

    const handleCloseSlipDialog = () => {
        setOpenSlipDialog(false);
    };

    const handleCloseTransferDialog = () => {
        setOpenTransferDialog(false);
    };

    const handleCloseWarrantyDialog = () => {
        setOpenWarrantyDialog(false);
    };

    const handleCloseActivityDialog = () => {
        setOpenActivityDialog(false);
    };

    ////////////////////////////////////
    //// UseEffect, triggers, calls ////
    ////////////////////////////////////

    useEffect(() => {
        setRentContractId(id);
    }, [id]);

    useEffect(function setFiltersEffect() {
        initalDataFilter();
    }, []);

    useEffect(function getInfo() {
        if (id) {
            getContract();
            getDocuments();
        }
    }, []);

    // useEffect(function contractDefaultInput() {
    //     if (!reqData?.start_date || !reqData?.active) {
    //         setReqData((prevState) => ({
    //             ...prevState,
    //             start_date: moment(),
    //             active: true,
    //         }));
    //     }
    // }, [reqData?.start_date, reqData?.active]);

    useEffect(function recipientSign() {
        getBonds();
    }, []);

    useEffect(
        function dueDayInvoice() {
            if (reqData?.bankslip_due_day) {
                setDataProvider((prevState) => ({
                    ...prevState,
                    invoiceDueDate: moment()
                        .set('date', reqData?.bankslip_due_day)
                        .format('YYYY-MM-DD'),
                }));
            } else {
                setDataProvider((prevState) => ({
                    ...prevState,
                    invoiceDueDate: moment()
                        .add(1, 'day')
                        .format('YYYY-MM-DD'),
                }));
            }
        },
        [reqData, setDataProvider]
    );

    useEffect(
        function disableSlipStep() {
            if (reqData?.bankslip_due_day) {
                setDataProvider((prevState) => ({
                    ...prevState,
                    enableSlip: true,
                }));
            }
        },
        [reqData, setDataProvider]
    );

    useEffect(
        function unitDetails() {
            detailedUnit();
        },
        [reqData?.unit]
    );

    useEffect(
        function disableRecipientStep() {
            const findRegister = dataBond.find((e) => e.id);

            if (findRegister) {
                setDataProvider((prevState) => ({
                    ...prevState,
                    enableRecipient: true,
                }));
            }
        },
        [dataBond, setDataProvider]
    );

    useEffect(
        function disableWarrantyStep() {
            const {
                value,
                due_date,
                insurance_company,
                insurance_policy_number,
                name,
                insurer,
                how_many_times_the_rent,
                description,
            } = guaranteeData || {};

            const conditionCred = value && due_date && insurance_policy_number;
            const conditionGuarantor = !!name;
            const conditionSeguro =
                value && insurance_policy_number && insurance_company;
            const conditionCaptialization =
                insurer && insurance_policy_number && how_many_times_the_rent;
            const conditionDeposit = description && value;

            let enableWarranty = false;

            if (guarantee === 'credpago') {
                enableWarranty = !!conditionCred;
            } else if (guarantee === 'guarantor') {
                enableWarranty = !!conditionGuarantor;
            } else if (guarantee === 'bail_insurance') {
                enableWarranty = !!conditionSeguro;
            } else if (guarantee === 'titulo_de_captalização') {
                enableWarranty = !!conditionCaptialization;
            } else if (guarantee === 'deposit') {
                enableWarranty = !!conditionDeposit;
            }

            setDataProvider((prevState) => ({
                ...prevState,
                enableWarranty,
            }));
        },
        [guaranteeData, guarantee, setDataProvider]
    );

    useEffect(
        function disabletaxStep() {
            setDataProvider((prevState) => ({
                ...prevState,
                enableCharge: dataCharge?.length,
            }));
        },
        [dataCharge, setDataProvider]
    );

    const handleReqData = (newReqData) => {
        setReqData(newReqData);
    };

    return (
        <>
            <Helmet>
                <title>{`${helmetTitle()} - Bloco B3`}</title>
            </Helmet>
            <Backdrop sx={{ color: '#fff', zIndex: 1500 }} open={loadingModal}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Container maxWidth={false}>
                <Grid container spacing={2}>
                    <Grid
                        item
                        xs={12}
                        lg={12}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'end',
                            gap: 1,
                            mb: 1,
                        }}
                    >
                        <Button
                            size="small"
                            startIcon={<PaidIcon />}
                            href={`/repasses/?rent_contract_id=${reqData?.id}`}
                            color="inherit"
                        >
                            Ver Repasses
                        </Button>
                        <Button
                            size="small"
                            startIcon={<ReceiptIcon />}
                            href={`/faturas/?rent_contract_id=${reqData?.id}`}
                            color="inherit"
                        >
                            Ver Faturas
                        </Button>

                        <Button
                            size="small"
                            variant="outlined"
                            color="secondary"
                            onClick={handleOpenOptionsMenu}
                            aria-controls={
                                optionsMenuOpen ? 'rent-options-menu' : undefined
                            }
                            aria-haspopup="true"
                            aria-expanded={optionsMenuOpen ? 'true' : undefined}
                            endIcon={<ArrowDropDownIcon />}
                        >
                            Mais Ações
                        </Button>

                        <Menu
                            id="rent-options-menu"
                            anchorEl={optionsAnchorEl}
                            open={optionsMenuOpen}
                            onClose={handleCloseOptionsMenu}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <MenuItem onClick={handleConfigureInvoice}>
                                <ReceiptIcon
                                    fontSize="small"
                                    style={{ marginRight: 8 }}
                                />
                                Configurar fatura
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={handleConfigureTransfer}>
                                <PaidIcon
                                    fontSize="small"
                                    style={{ marginRight: 8 }}
                                />
                                Configurar repasse
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={handleConfigureWarranty}>
                                <SettingsIcon
                                    fontSize="small"
                                    style={{ marginRight: 8 }}
                                />
                                Garantia / Seguro
                            </MenuItem>
                            {id && (
                                <>
                                    <Divider />
                                    <MenuItem onClick={handleOpenActivity}>
                                        <HistoryIcon
                                            fontSize="small"
                                            style={{ marginRight: 8 }}
                                        />
                                        Logs de atividades
                                    </MenuItem>
                                </>
                            )}
                        </Menu>
                    </Grid>

                    <Grid item xs={12} lg={8}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <RentContractFee reqData={reqData} />
                            </Grid>

                            <Grid item xs={12} lg={12}>
                                { reqData?.id && <BeneficiariesTableView data={reqData} onSaved={getContract} /> }
                            </Grid>
                            <Grid item xs={12} lg={12}>
                                {id && (
                                    <RentNotes
                                        rentNotes={rentNotes}
                                        setRentNotes={setRentNotes}
                                        isLoading={isLoading}
                                    />
                                )}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} lg={4}>
                        <ContractForm
                            prevStateData={prevStateData}
                            contractLoad={contractLoad}
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                            reqData={reqData}
                            setReqData={setReqData}
                            unitOptions={unitOptions}
                            error={error}
                            getContract={getContract}
                            update={update}
                        />

                        <RenterInfo
                            reqData={reqData}
                            setFilters={setFilters}
                            unitInfo={unitInfo}
                            isLoading={isLoading}
                        />

                        <RentDocuments
                            loadingDocuments={loadingDocuments}
                            getDocuments={getDocuments}
                            documentPromise={documentPromise}
                        />

                        {reqData?.status === 'active' && (
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                width="100%"
                                marginTop={'1.5rem'}
                            >
                                <TerminateContractForm
                                    open={open}
                                    params={params}
                                    handleClose={() => setOpen(false)}
                                    updateReqData={handleReqData}
                                />
                            </Box>
                        )}

                        {reqData?.status === 'inactive' &&
                            reqData?.warning_date && (
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    width="100%"
                                    marginTop={'1.5rem'}
                                >
                                    <TerminateContractDetail
                                        open={open}
                                        params={params}
                                        handleClose={() =>
                                            setOpen(false)
                                        }
                                        data={reqData}
                                    />
                                </Box>
                            )}
                    </Grid>



                </Grid>

                {/* Dialog para configurar fatura (RentSlipOptions) */}
                <Dialog
                    open={openSlipDialog}
                    onClose={handleCloseSlipDialog}
                    fullWidth
                    maxWidth="sm"
                    sx={{ background: 'transparent' }}
                >
                    <DialogContent dividers sx={{ p: 0 }}>
                        <RentSlipOptions
                            disableCardWrapper
                            getContract={getContract}
                            update={update}
                            prevStateData={prevStateData}
                            reqData={reqData}
                            setReqData={setReqData}
                            isLoading={isLoading}
                            error={error}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseSlipDialog}>Fechar</Button>
                    </DialogActions>
                </Dialog>

                {/* Dialog para configurar repasse (AutoTransfer) */}
                <Dialog
                    open={openTransferDialog}
                    onClose={handleCloseTransferDialog}
                    fullWidth
                    maxWidth="sm"
                    sx={{ background: 'transparent' }}
                >
                    <DialogContent dividers sx={{ p: 0 }}>
                        <AutoTransfer
                            disableCardWrapper
                            reqData={reqData}
                            setReqData={setReqData}
                            getContract={getContract}
                            prevStateData={prevStateData}
                            error={error}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseTransferDialog}>
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Dialog para Garantia / Seguro (RentWarranty) */}
                <Dialog
                    open={openWarrantyDialog}
                    onClose={handleCloseWarrantyDialog}
                    fullWidth
                    maxWidth="md"
                    sx={{ background: 'transparent' }}
                >
                    <DialogTitle>Garantia / Seguro</DialogTitle>
                    <DialogContent dividers sx={{ p: 0 }}>
                        <RentWarranty
                            rentData={reqData}
                            guaranteeData={guaranteeData}
                            setGuaranteeData={setGuaranteeData}
                            insuranceData={insuranceData}
                            setInsuranceData={setInsuranceData}
                            guarantee={guarantee}
                            setGuarantee={setGuarantee}
                            isLoading={isLoading}
                            getContract={getContract}
                            update={update}
                            setIsLoading={setIsLoading}
                            show={show}
                            setShow={setShow}
                            warrantyChoice={warrantyChoice}
                            getWarranty={getGuarantee}
                            getInsurance={getInsurance}
                            prevWarranty={prevWarranty}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseWarrantyDialog}>
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Dialog para Histórico (ActivityLog) */}
                <Dialog
                    open={openActivityDialog}
                    onClose={handleCloseActivityDialog}
                    fullWidth
                    maxWidth="md"
                    sx={{ background: 'transparent' }}
                >

                    <DialogContent dividers sx={{ p: 0 }}>
                        <ActivityLog activities={reqData?.history} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseActivityDialog}>
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>

                <SimpleButtons type={'button'} />
            </Container>
        </>
    );
};

export default RentForm;
